/**
 * computeMonthlyLeasingRepPenalty — pénalité de réputation liée au ratio
 * de leasing sur la flotte, appliquée en début de mois.
 *
 * 11/02/2026 (Phase 5 v2 — Dette technique).
 * Extrait du bloc inline `coreSlice.nextDay` (lignes 1475-1489).
 *
 * Règle métier :
 *   Si `phase < 3` et flotte ≥ 5 véhicules, on regarde le ratio de véhicules
 *   loués (isLeased). Au-delà de 70% de leasing, le marché lit ça comme
 *   "société peu solide, faible patrimoine" → pénalité linéaire de
 *   -1 réputation par +10% au-delà du seuil, plafonnée à -3.
 *   En phase 3+ (groupes financiers), le leasing est traité normalement,
 *   pas de pénalité.
 *
 * @param {object} state — { phase, vehicles: [{ isLeased }] }
 * @param {number} newDay — le jour dans le mois (1 = début de mois)
 * @returns {number} Pénalité entière négative (0 si aucune).
 */
export function computeMonthlyLeasingRepPenalty(state, newDay) {
  if (newDay !== 1) return 0;
  const phase = state.phase || 1;
  if (phase >= 3) return 0;
  const fleet = state.vehicles || [];
  if (fleet.length < 5) return 0;
  const leasedCount = fleet.filter((v) => v && v.isLeased).length;
  const ratio = leasedCount / fleet.length;
  if (ratio <= 0.70) return 0;
  return -Math.min(3, Math.round((ratio - 0.70) * 30));
}
